import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeFromCart, showModal, cleanShoppingCartStore } from './actions';
import { switchCheckoutContent } from '../../workflow/checkout/checkoutContent/actions';
import { changeContent } from '../../workflow/checkout/services/actions';
import ModalComponent from './modal.component'
import { Row, Col } from 'react-bootstrap';
import { configuration } from '../../configuration'

class CartItems extends React.Component {

  static propTypes = {
    isNewAppointment: PropTypes.bool,
  }

  removeFromCart(index, serviceId) {
    this.props.removeFromCart(index, serviceId);
    if (this.props.services.router === 'observations'
      && this.props.services.element.serviceId === this.props.cart.items[index].serviceId) {
      this.props.changeContent(null);
    }
    if (this.props.cart.items.length === 1) {
      this.props.switchCheckoutContent('services');
    }

    let numberOfMainServices = _.filter(this.props.cart.items, (item) =>{
      return item.isAdditional != true
    })

    if (numberOfMainServices.length === 1){
      this.props.cleanShoppingCartStore("*");
    }
  };

  showModal(isVisible, content) {
    this.props.showModal(isVisible, content);
  }


  render() {
    let renderEjeIcon = (this.props.tokenStatus === 'validNonForfaitToken')
    return (
      <div>
        <ul style={{color: configuration().clientColor}}>
          {
            (this.props.cart.items.filter(e => !e.isAdditional)).map((element, index) => {
              let name = element.name;
              return (
                <li key={index}>
                  <Row>
                    <Col sm={12} md={6} className="textOverflow">
                      <span className="item-title" title={name}>{name}</span>&nbsp;
                    </Col>
                  {
                    !renderEjeIcon
                      ? (
                        <React.Fragment>
                            <Col sm={6} md={3}>
                              <a href='javascript:void(0);' style={{ color: configuration().clientColor, textDecoration: 'underline' }} className='a-delete' onClick={() => this.removeFromCart(index, element._id)}>ELIMINAR</a>
                            </Col>
                        </React.Fragment>
                      )
                      : null
                  }
                    <Col sm={6} md={3}>
                  <span className="pull-right price noWrap">

                    {typeof element.price === 'number' && !_.isNaN(element.price) ? parseFloat(parseFloat(element.price) * parseFloat(configuration().ivaConfigTaxesSin)).toFixed(2) : '-.-'} €{configuration().ivaConfigTextCon}
                  </span>
                    </Col>
                  {renderEjeIcon && element.serviceLines.length > 0 &&
                    <span style={{ display: 'block' }}>
                      <a href="javascript:void(0);" className="show-budget" onClick={() => this.showModal(true, element)}>
                        VER PRESUPUESTO
                      </a>
                    </span>
                  }
                  </Row>
                </li>
              )
            })
          }
        </ul>
        <ModalComponent service={this.props.modal.content} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    services: state.checkout.servicesData,
    cart: state.checkout.shoppingCart,
    modal: state.checkout.shoppingCart.modal,
    tokenStatus: state.checkout.checkoutRoot.tokenStatus,
  }
}

const bindActions = dispatch => ({
    removeFromCart: (index, serviceId) => dispatch(removeFromCart(index, serviceId)),
    switchCheckoutContent: (content) => dispatch(switchCheckoutContent(content)),
    changeContent: (content) => dispatch(changeContent(content)),
    showModal: (isVisible, content) => dispatch(showModal(isVisible, content)),
    cleanShoppingCartStore: (props) => dispatch(cleanShoppingCartStore(props)),

});

export default connect(mapStateToProps, bindActions)(CartItems);



// WEBPACK FOOTER //
// ./src/components/shoppingCart/cartItems.js